import axiosInstance from "../../../axios/axios";
import AuctionEntryItem from '../models/AuctionEntryItem';

export function getOpendAuctions() {
    return new Promise((resolve, reject) => {
        const lang = localStorage.getItem('eahsLang') ?? 'en';
        const ownerId = localStorage.getItem('currentSubAccountId');
        axiosInstance.get(`/AuctionEntry/GetAuctionEntry?langauge=${lang}&ownerId=${ownerId}`,).then(response => {
            debugger;
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data.result;
                    const formatted = (res || []).map(item => new AuctionEntryItem(item));
                    resolve(formatted ?? false)
                }
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}
export function getAuctionEntryDetials(auctionId) {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/auctionentry/getauctionentrybyid?auctionId=${auctionId}`,).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data.result;
                    resolve(res ?? false)
                }
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}
export function AddEditAuctionHorse(formData) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/AuctionEntry/AddEditAuctionHorse?language=1`, formData, {
            headers: {
                'content-type': 'multipart/form-data',
            }
        }).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data.result;
                    resolve(res ?? false)
                } else {
                    const res = response.data;
                    resolve(res ?? false)
                }

            }
            resolve([]);
        }).catch(error => reject([]))
    })
}
export function DeleteAuctionHorse(auctionHorseId) {
    const createdBy = localStorage.getItem('EAHSUserID') ?? '';
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/AuctionEntry/DeleteAuctionHorse?id=${auctionHorseId}&createdBy=${createdBy}&language=1`).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data.result;
                    resolve(res ?? false)
                }
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}
export function SubmitAuctionHorses(auctionId) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/AuctionEntry/SubmitAuctionHorses`, { id: auctionId }).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    resolve(true)
                }
            }
            resolve(false);
        }).catch(error => reject(false))
    })
}
export function GetAuctionHorseRequestById(auctionHorseId) {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/auctionentry/getauctionhorserequestbyid?auctionHorseId=${auctionHorseId}`).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data.result;
                    resolve(res ?? false)
                }
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}
export function GetAuctionHorsesRequests(ownerId, auctionId) {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/auctionentry/GetAuctionHorsesRequests?ownerId=${ownerId}&auctionId=${auctionId}&language=1`).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data.result;
                    resolve(res ?? false)
                }
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}

export function getAuctionEntryOwnerHorses(ownerId = "", auctionId = '') {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/AuctionEntry/GetAuctionEntryOwnerHorses`, {
            auctionId: auctionId,
            ownerId: ownerId,
            createdBy: ownerId,
        }).then(response => {
            if (response.status == 200) {
                const formatedData = response.data.horsesList.map((horse) => ({
                    isSelected: !!!horse?.auctionHorseStatus ? false : true,
                    name: horse?.name,
                    regNr: horse?.registerNumber,
                    ownerName: horse?.owner,
                    origin: horse?.origin,
                    id: horse?.id,
                    status: horse?.auctionHorseStatus?.toLowerCase() == 'new' ? 'completed' : horse?.auctionHorseStatus?.toLowerCase() == 'approval' ? 'new' : horse?.auctionHorseStatus,
                    birthDate: horse?.birthDate,
                    auctionHorseId: horse?.auctionHorseId ?? '',
                    gender: horse?.gender ?? ''
                }));
                resolve(formatedData ?? [])
            }
            resolve([]);
        }).catch(error => reject(false))
    })
}